import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './check-box.scss';

const CheckBox = ({ id, name, checked, disabled, callbackOnChange }) => (
    <div className={css.checkbox}>
        <input
          type="checkbox"
          className={css.filter}
          id={id + name}
          value={id}
          name={id}
          checked={checked}
          disabled={disabled}
          onChange={callbackOnChange}
        />

        <label className={css.chklabel} htmlFor={id + name} />
        <span className={css.filterName}>{name}</span>
    </div>
);

CheckBox.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    callbackOnChange: PropTypes.func
};

export default CheckBox;
